// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"f0e8df8d","446":"2e64e77b","758":"a9ef968c"}[chunkId] + ".chunk.js";
};